/**
 * Created by decipaliz on 19.03.2024
 */

FieldView.prototype.onShowUpFloor = function (callback) {
    callback();
};